document.addEventListener("alpine:init", () => {
    Alpine.data("secondaryNavigation", () => ({
        loaded: false,
        menuOpen: false,
        positionTop: 0,
        currentID: null,
        sections: null,
        currentLink: null,
        init() {
            this.positionTop = pegasus.getElemOffset(this.$el);

            const navLinks = this.$refs.navLinks.querySelectorAll("li");

            this.currentLink = navLinks[0]
                .querySelector("a")
                .getAttribute("href");

            this.checkPosition(true);
        },
        isAnchor(link) {
            this.menuOpen = false;
            // Only apply if link is using anchors

            if (link.hash || link.startsWith("#")) {
                let anchor = link.hash
                    ? link.hash.substring(1)
                    : link.substring(1);
                console.log(anchor);

                const sections = document.querySelectorAll(
                    ".Pegasus__Container",
                );

                sections.forEach((element) => {
                    if (element.id === anchor) {
                        let section = element;
                        console.log(section);
                        const yOffset = -90;
                        const y =
                            section.getBoundingClientRect().top +
                            window.scrollY +
                            yOffset;

                        window.scrollTo({ top: y, behavior: "smooth" });
                    }
                });

                this.fix();
            } else {
                window.location = link;
            }
        },
        checkPosition(onLoad = false) {
            const contentRows = document.querySelectorAll(
                ".Pegasus__Container",
            );
            const windowOffset = window.outerHeight / 4;

            contentRows.forEach((row) => {
                if (
                    typeof row.id === "undefined" ||
                    row.id === null ||
                    row.id === ""
                ) {
                    return false;
                }
                const rowTop = pegasus.getElemOffset(row).top,
                    rowBottom = pegasus.getElemOffset(row).bottom;

                let st = window.scrollY;

                if (onLoad) {
                    if (
                        window.scrollY + windowOffset >= rowTop &&
                        window.scrollY + windowOffset <= rowBottom
                    ) {
                        this.currentLink = "#" + row.id;
                    }
                }

                if (st >= this.lastScrollTop) {
                    //Scroll Down
                    if (
                        window.scrollY + windowOffset >= rowTop &&
                        window.scrollY + windowOffset <= rowBottom
                    ) {
                        this.currentLink = "#" + row.id;
                    }
                } else {
                    //Scroll Up
                    if (
                        window.scrollY - windowOffset <= rowBottom &&
                        window.scrollY - windowOffset >= rowTop
                    ) {
                        this.currentLink = "#" + row.id;
                    }
                }

                this.lastScrollTop = st;
            });
        },
    }));
});
